// extracted by mini-css-extract-plugin
module.exports = {"paginationRow":"Paginate_paginationRow__3263a","pageSize":"Paginate_pageSize__1b6sQ"};